import { ChangeDetectorRef, Directive, ElementRef, Host, HostListener, Input, OnInit, Optional, Self } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { ElementControlService } from 'src/app/core/services/element-control.service';

/**
 * 輸入字串清除 Directive
 *
 * @export
 * @class InputTrimDirective
 * @implements {OnInit}
 */
@Directive({
  selector: '[sigvInputTrim]'
})
export class InputTrimDirective implements OnInit {

  @Input('inputControl') inputControl?: AbstractControl | null;

  constructor(
    @Host() @Self() @Optional() private ngControl: NgModel,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
    private elementControlService: ElementControlService) {
  }

  hasWhitespace = (s: string): boolean => {
    const whitespaceChars: string[] = [' ', '　',
      '\b', '\t', '\n', '\v', '\f', '\r', `\"`, `\'`, `\\`,
      '\u0008', '\u0009', '\u000A', '\u000B', '\u000C',
      '\u000D', '\u0020', '\u0022', '\u0027', '\u005C',
      '\u00A0', '\u2028', '\u2029', '\uFEFF'];
    return whitespaceChars.some(char => s.includes(char));
  };


  get ctrl() {
    if (this.inputControl) {
      return this.inputControl;
    }
    else if(this.ngControl){
      return this.ngControl.control;
    }
    return null;
  }

  ngOnInit(): void { }


  @HostListener('keyup')
  onKeyup() {
    this.inputTrim();
  }

  private inputTrim() {
    setTimeout(() => {
      if (this.ctrl && this.ctrl.value) {
        if (this.hasWhitespace(this.ctrl.value)) {
          this.ctrl.setValue(this.ctrl.value.trim());
          this.cd.detectChanges();
        }
      }
    }, 0);
  }

}
